import { useState, useEffect } from 'react';
import getEnv from '../env';

const API_URL = getEnv('REACT_APP_API_URL') || 'http://localhost:8000';
const POLL_INTERVAL_MS = 10000;

function useBackendHealth() {
    const [isReachable, setIsReachable] = useState(true);

    useEffect(() => {
        const check = async () => {
            try {
                const res = await fetch(`${API_URL}/health`, { method: 'GET' });
                setIsReachable(res.ok);
            } catch {
                setIsReachable(false);
            }
        };

        check();
        const interval = setInterval(check, POLL_INTERVAL_MS);
        return () => clearInterval(interval);
    }, []);

    return isReachable;
}

export default useBackendHealth;
